export const SENTENCE_REGEX = /([^.!?]+[.!?])\s*|$/g;
const WEB_SITE_REGEX = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm;

export class TextBuffer {
  private buffer = "";
  private timeout: ReturnType<typeof setTimeout> | null = null;
  private readonly evictionTimeout = 500;

  constructor(
    private readonly onEvict: (text: string) => void,
    private readonly evictFullSentence = true,
  ) {
    if (!onEvict) {
      throw new Error("onEvict is required");
    }
  }

  addText(text: string): void {
    if (text) {
      this.buffer += text;
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.processBuffer();

    this.timeout = setTimeout(
      () => this.processBuffer(true),
      this.evictionTimeout,
    );
  }

  private processBuffer(forceEvict?: boolean): void {
    const webRegExp = new RegExp(WEB_SITE_REGEX);
    if (this.evictFullSentence && !webRegExp.test(this.buffer)) {
      const sentences = this.buffer.match(SENTENCE_REGEX) || [];
      const fullSentences = sentences.join("");
      this.buffer = this.buffer.replace(fullSentences, "");
      if (fullSentences.length) {
        this.onEvict(fullSentences);
      }
    }

    if (forceEvict && this.buffer.length) {
      this.onEvict(this.buffer);
      this.buffer = "";
    }
  }

  close(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.buffer = "";
  }
}
